/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Injectable} from '@angular/core';
import {map, Observable} from 'rxjs';

import {ApiConfig} from '../../config/api-config';
import {AdnApiClientService} from './adn-api-client.service';

@Injectable({providedIn: 'root'})
export class AvailableCurrenciesApiService {
  constructor(private readonly client: AdnApiClientService, private readonly apiConfig: ApiConfig) {
  }

  get(): Observable<any[]> {
    return this.client.request<{results: any[]}>({
      method: 'GET',
      url: this.apiConfig.getVersionedUri('availablecurrencies')
    }).pipe(map((page) => page.results || []));
  }
}
